<template>
  <div v-if="alarmDialogVisible">
    <el-dialog width="30%" center class="alarm-style"
        title="異常告警" 
        :class="(dialogEvent.img && dialogEvent.img != '') ? 'alarm-hasVideo':''" 
        :append-to-body="true" 
        :show-close="false" 
        :close-on-click-modal="false"
        :visible.sync="alarmDialogVisible" 
        >
      <div slot="title"><span class="el-dialog__title"><i class="dialog-icon i-alarm"></i>異常告警</span></div>
      <div class="content-label">時間: <span>{{dialogEvent.time}}</span></div>
      <div class="content-label">事件: <span>{{dialogEvent.content}}</span></div>
      <div class="alarm-video" style="width: 100%;" v-loading="imgLoading">
        <!-- <iframe 
          id="iframe" name="iframe" ref="iframe" 
          seamless scrolling="no" 
          width="100%" height="100%" frameBorder="0"
          v-if="showIframe" :src="src" @load="iframeLoaded"
          >
        </iframe> -->
        <img :src="src" alt="" width="100%" height="100%" v-if="showIframe">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button icon="dialog-btn-icon al-play" class="btn-al-check" @click="checkLiveView" v-if="(dialogEvent.img && dialogEvent.img != '')">查看狀況</el-button>
        <!-- <el-button icon="dialog-btn-icon al-switch-on" class="btn-al-switch" @click="stopAlarm">解除警報</el-button> -->
        <div style="padding-top:25px;cursor: pointer;font-size: 20px;"><span class="btn-alarm-confirm" @click="handleClose" role="button">確認</span></div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { mapActions } from 'vuex'
const evDefault = {
        time: '',
        content: '',
        link: []
      }
export default {
  props: {
    isDialogVisible: {
      type: Boolean,
      default: false
    },
    dialogEvent: {
      type: Object,
      default: () => {
        return evDefault
      }
    }
  },
  data: function () {
    return {
      alarmDialogVisible: false,
      alarmEvent: {},
      showIframe: false,
      // src: process.env.BASE_URL+ 'alarm.html?' + Date.now(), // 禾倉頁面
      src: '',
      iframeWin: '',
      imgLoading: false
    }
  },
  watch: {
    alarmDialogVisible: function(isDialogVisible){
      // 放這裡監聽不放mounted是因為dialog元件只會載入一次，但這個狀態每次彈窗都會變化
      if (isDialogVisible) {
        this.alarmEvent = this.dialogEvent
        // 等待DOM載入完成
        this.$nextTick(function(){
          $('.alarm-video').css( 'height', $(".alarm-hasVideo .el-dialog").height())
          $('.alarm-video').css( 'width', $(".alarm-hasVideo .el-dialog").height()*(896/504))
          let vm = this
          if (vm.alarmEvent.img && vm.alarmEvent.img != '') {
            this.imgLoading = true
            let imgUrl = process.env.VUE_APP_FILE_URL +'/'+ vm.alarmEvent.img
            vm.isHasImg(imgUrl)
          }

          // if (vm.dialogEvent.link.length > 0) {
          //   vm.showIframe = true
          // }

          // if (vm.alarmEvent.nvrDevId?.startsWith('ALST')) {
          //   vm.src = process.env.BASE_URL+ 'alarm.html?' + Date.now() // 禾倉頁面
          // } else if (vm.alarmEvent.nvrDevId?.startsWith('HUST')) {
          //   vm.src = process.env.BASE_URL+ 'huntAlarm.html?' + Date.now() // 杭特頁面
          // } else {
          //   vm.src = process.env.BASE_URL+ 'blank.html' // 顯示沒有對應NVR訊息
          // }

          // // 避免影像直播頁面的內容影響到
          if ($('#AsViewer')) {
            $('#Live_Content').removeClass("d-flex").addClass('d-none')
          }
        })
      }
    }
  },
  mounted(){
    this.alarmDialogVisible = this.isDialogVisible
    // window.addEventListener('message', this.handleMessage) //收iframe訊息，用不到
  },
  beforeDestroy: function() {
    // window.removeEventListener('message', this.handleMessage)
    // this.removeView()
  },
  methods: {
    ...mapActions('deviceModule', [ 'setSwById' ]),

    // 等待iframe載入完畢
    // iframeLoaded() {
    //   this.iframeWin = this.$refs.iframe.contentWindow

    //   this.iframeWin.setChannels(this.alarmEvent.link)
    //   if (this.alarmEvent.nvrDevId?.startsWith('ALST')) {
    //     this.iframeWin.initPlayer()
    //   } else if (this.alarmEvent.nvrDevId?.startsWith('HUST')) {
    //     var g_NVR =
    //     [
    //       {
    //         "ip": this.alarmEvent.link[0].ip,
    //         "port": this.alarmEvent.link[0].port,
    //         "user": this.alarmEvent.link[0].acc,
    //         "password": this.alarmEvent.link[0].pwd
    //       }
    //     ]
    //     this.iframeWin.initPlayer(g_NVR)
    //   }
    // },

    removeView() {
      if ($('#AsViewer')) {
        $('#Live_Content').addClass("d-flex").removeClass('d-none')
      }
      // if (this.showIframe && this.iframeWin.ocxPlayer && this.iframeWin.ocxPlayer?.stopStream) {
      //   this.iframeWin.stopVideo()
      // }
      this.showIframe = false
    },
    handleClose() {
      this.removeView()
      let vm = this
      setTimeout(() => { // 緩一下，讓iframe確實關閉，不然會出問題
        vm.$emit('onCloseDialog')
        vm.alarmDialogVisible = false
      }, 100);
    },
    checkLiveView() {
      this.handleClose()
      this.$router.push({ name: 'video-liveView' })
    },
    stopAlarm: function() {
      // let postBody = {
      //   deviceId: this.alarmEvent.triggerdevid, //TODO 目前還不知道要解除哪一個設備
      //   "sw":0
      // }
      // this.setSwById(postBody)
      //   .catch(rej => {
      //     console.log(rej)
      //   })
    },
    isHasImg: function(pathImg){
      let vm = this
      var ImgObj = new Image()
      ImgObj.src = pathImg
      // 判斷圖片是否存在
      if(ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
        vm.src = pathImg
        vm.showIframe = true
        vm.imgLoading = false
      } else {
        setTimeout(function(){
          vm.isHasImg(pathImg)
        }, 100)
      }
    }
  },
}
</script>

<style
  lang="css"
  src="@STYLE/pages/video/alarm_style.css"
></style>